// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiHost: 'http://localhost:4214',
  apiUrls: {
    npc: {
      private: 'nct/api/v1/private',
      public:  'nct/api/v1/public',
      auth:    'nct/api/v1/auth' 
    },
    files: {
      private: 'files-service/api/v1/private',
      public:  'files-service/api/v1/public',
    },
    integrationKaspi: {
      private: 'integration-kaspi/api/v1/private',
      public:  'integration-kaspi/api/v1/public',
    },
    integrationOzon: {
      private: 'integration-ozon/api/v1/private',
      public:  'integration-ozon/api/v1/public',
    },
    integrationMarking: {
      private: 'integration-marking/api/v1/private',
      public:  'integration-marking/api/v1/public',
    },
    npcapi: {
      private: 'npcapi/api/v1/private',
      public:  'npcapi/api/v1/public',
    }

  },
  ws: 'wss://128.10.10.224:8443/websocket-server/nct-websocket'
  //ws: 'wss://demo.piesocket.com/v3/channel_1?api_key=oCdCMcMPQpbvNjUIzqtvF1d2X2okWpDQj4AwARJuAgtjhzKxVEjQU6IdCjwm&notify_self',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
